import React, {useState, useEffect, useContext} from 'react';
import GlobalContext from '../../context/global-context';
import { useTheme } from '@material-ui/core/styles';
import Helpers from '../global/helpers';

import { 
    Button,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    TextField,
    DialogContentText,
    InputLabel,
    Typography
} from '@material-ui/core';


const AddInvoiceDetails = props => {

    // Create a local state
    const [params, setParams] = React.useState({
        proforma_issued: null,
        invoice_to: null
    });

    // Use the global context
    const context = useContext(GlobalContext);

    const handleChange = e => {
        let newParams = {...params};
        newParams[e.target.name] = e.target.value;
        setParams(newParams);
    }

    const handleUpdateInvoiceNo = () => {
        const newParams = {
            selected: props.selected,
            ...params
        }
        context.updateSubscriptionsAs(newParams, 'invoice_details').then(
            res => {
                context.showAlert('success', 'Invoice info updated');

                if(typeof props.success == 'function')
                    props.success()
            },
            err => {
                context.showAlert('error', 'Error updating subscriptions ' + JSON.stringify(err))
            }
        )
    }

    const handleActionCancel = () => {
        setParams({
            proforma_issued: null,
            invoice_to: null
        });

        if(typeof props.close == 'function')
            props.close()
    }

        
    return (

        <Dialog open={props.show} onClose={props.close} aria-labelledby="invoice-no-dialog-title">
            <DialogContent>
                <TextField
                    labelId="proforma_issued-label"
                    label="Proforma Issued"
                    type="date"
                    autoFocus
                    margin="dense"
                    name="proforma_issued"
                    value={params.proforma_issued}
                    onChange={handleChange}
                    fullWidth
                    InputLabelProps={{shrink: true}}
                />
            </DialogContent>
            <DialogContent>
                <TextField
                    margin="dense"
                    name="invoice_to"
                    value={params.invoice_to}
                    onChange={handleChange}
                    label="Invoice to"
                    type="text"
                    fullWidth
                    InputLabelProps={{shrink: true}}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleActionCancel} color="default">
                    Cancel
                </Button>
                <Button onClick={handleUpdateInvoiceNo} color="secondary">
                    Add
                </Button>
            </DialogActions>
        </Dialog>

    );
}

export default AddInvoiceDetails